"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _DataDisplayWidget = _interopRequireDefault(require("./Style/DataDisplayWidget"));

var _axios = _interopRequireDefault(require("axios"));

var _errorPage = _interopRequireDefault(require("../../../error-views/errorPage"));

// import { useHistory } from 'react-router-dom';
var Panel = _antd.Collapse.Panel;
var newFourParent = [];
var panelIndex = 0;
var panelIndexArray = [];

var ParentAudit = function ParentAudit(_ref) {
  var RMCode = _ref.RMCode;
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _Form$useForm = _antd.Form.useForm(),
      _Form$useForm2 = (0, _slicedToArray2.default)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      fourParent = _useState2[0],
      setFourParent = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      warningBack = _useState4[0],
      setwarningBack = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      filledData = _useState6[0],
      setFilledData = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      apiError = _useState10[0],
      setapiError = _useState10[1]; // const history = useHistory();
  // useEffect(async () => {
  //     let url = config.getParentAuditData + cl + '&RMcode=' + RMCode;
  //     axios.get(url, { headers: { 'Authorization': token } })
  //         .then(resp => {
  //             if (resp.data.status === "error") setapiError(resp.data);
  //             // console.log(resp.data)
  //             newFourParent = resp.data
  //             setFourParent(resp.data)
  //             setLoading(false)
  //         }, error => {
  //             setapiError(error.response);
  //         });
  //     // let filterData = newFourParent.filter((item) => item.RM_send_morning_messages !== "" || item.Does_RM_follow_up !== "" || item.Does_RM_tell_marks_daily !== "" || item.Total_working_days !== "")
  //     let filterData = newFourParent.filter((item) =>  item.Total_working_days !== "")
  //     setFilledData(filterData.length)
  // }, [])


  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var url, filterData;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _config.default.getParentAuditData + cl + '&RMcode=' + RMCode;

                _axios.default.get(url, {
                  headers: {
                    'Authorization': token
                  }
                }).then(function (resp) {
                  if (resp.data.status === "error") setapiError(resp.data); // console.log(resp.data)

                  newFourParent = resp.data;
                  setFourParent(resp.data);
                  setLoading(false);
                }, function (error) {
                  setapiError(error.response);
                }); // let filterData = newFourParent.filter((item) => item.RM_send_morning_messages !== "" || item.Does_RM_follow_up !== "" || item.Does_RM_tell_marks_daily !== "" || item.Total_working_days !== "")


                filterData = newFourParent.filter(function (item) {
                  return item.Total_working_days !== "";
                });
                setFilledData(filterData.length);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, []);

  var panelChange = function panelChange(value) {
    panelIndex = value;
    panelIndexArray.push(value);
  };

  var onChange = function onChange(e) {
    newFourParent[panelIndex].Total_working_days = e.target.value; // let filterData = newFourParent.filter((item) => (item.RM_send_morning_messages !== "" || item.Does_RM_follow_up !== "" || item.Does_RM_tell_marks_daily !== "") && item.Total_working_days !== "")

    var filterData = newFourParent.filter(function (item) {
      return item.Total_working_days !== "";
    });
    setFilledData(filterData.length);
  };

  var selectOption = function selectOption(e) {
    // console.log(e)
    var value = e.target.value;
    var checked = e.target.checked; // let onevalue = value.findIndex((item => item === 'RM_send_morning_messages'))
    // let twovalue = value.findIndex((item => item === 'Does_RM_follow_up'))
    // let threevalue = value.findIndex((item => item === 'Does_RM_tell_marks_daily'))
    // let onevalue = value === 'RM_send_morning_messages'
    // let twovalue = value === 'Does_RM_follow_up'
    // let threevalue = value=== 'Does_RM_tell_marks_daily'

    if (value === 'RM_send_morning_messages') {
      if (checked) newFourParent[panelIndex].RM_send_morning_messages = "1";else newFourParent[panelIndex].RM_send_morning_messages = "0";
    }

    if (value === 'Does_RM_follow_up') {
      if (checked) newFourParent[panelIndex].Does_RM_follow_up = "1";else newFourParent[panelIndex].Does_RM_follow_up = "0";
    }

    if (value === 'Does_RM_tell_marks_daily') {
      if (checked) newFourParent[panelIndex].Does_RM_tell_marks_daily = "1";else newFourParent[panelIndex].Does_RM_tell_marks_daily = "0";
    } // let filterData = newFourParent.filter((item) => (item.RM_send_morning_messages !== "" || item.Does_RM_follow_up !== "" || item.Does_RM_tell_marks_daily !== "") && item.Total_working_days !== "")


    var filterData = newFourParent.filter(function (item) {
      return item.Total_working_days !== "";
    });
    setFilledData(filterData.length);
  };

  var submit = function submit() {
    // let filterData = newFourParent.filter((item) => (item.RM_send_morning_messages === "" || item.Does_RM_follow_up === "" || item.Does_RM_tell_marks_daily === "") && item.Total_working_days === "")
    // let filterData = newFourParent.filter((item) => item.Total_working_days === "")
    // let filterNewData = newFourParent.filter((item) => (item.RM_send_morning_messages !== "" || item.Does_RM_follow_up !== "" || item.Does_RM_tell_marks_daily !== "") && item.Total_working_days !== "")
    var filterNewData = newFourParent.filter(function (item) {
      return item.Total_working_days !== "";
    });
    var finalFarentAuditScore = parentAuditScoreCalc(); // if (newFourParent.length === filterData.length || filterData.length === 4) {

    if (filterNewData.length === 0) {
      alert('Audit not done. Please do 2 parent audit');
    } else if (filterNewData.length === 1) {
      alert('You have Done only 1 parent Audit. Please do 1 more parent audit');
    } // else if (filterNewData.length === 2 || newFourParent.length - filterNewData.length === 2) {
    else if (filterNewData.length === 2) {
        var url = _config.default.postParentAuditresponse + cl + '&RMcode=' + RMCode;

        _axios.default.post(url, {
          parentData: filterNewData
        }).then(function (resp) {
          if (resp.data.status === "error") setapiError(resp.data); // window.location = "/clPortal/app/rm/audit";
        }, function (error) {
          setapiError(error.response);
        });

        var url2 = _config.default.postAuditParentScore + cl + '&RMcode=' + RMCode;

        _axios.default.post(url2, {
          finalFarentAuditScore: finalFarentAuditScore
        }).then(function (resp) {
          if (resp.data.status === "error") setapiError(resp.data);
          alert("Today's Parent Audit done Successfully!");
          window.location = "/clPortal/app/rm/audit";
        }, function (error) {
          setapiError(error.response);
        });
      } else {
        alert('You have done more than 2 parent audit. Please refresh the page and fill again.');
      }
  };

  var parentAuditScoreCalc = function parentAuditScoreCalc() {
    // let filterNewData = newFourParent.filter((item) => (item.RM_send_morning_messages !== "" || item.Does_RM_follow_up !== "" || item.Does_RM_tell_marks_daily !== "") && item.Total_working_days !== "")
    var filterNewData = newFourParent.filter(function (item) {
      return item.Total_working_days !== "";
    });
    var positiveScore = filterNewData.length * 3;
    var negativeScore = filterNewData.reduce(function (acc, cur) {
      if (cur.RM_send_morning_messages === "0") ++acc;
      if (cur.Does_RM_follow_up === "0") ++acc;
      if (cur.Does_RM_tell_marks_daily === "0") ++acc;
      return acc;
    }, 0);
    var parentAuditScore = (positiveScore - negativeScore) / positiveScore * 100;
    return Math.round(parentAuditScore, 2);
  };

  var back = function back() {
    setwarningBack(!warningBack);
  };

  function cancel(e) {
    setwarningBack(false);
    window.location = _config.default.getAuditBackButtonLink;
  }

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24,
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [8, 8]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 16,
    xl: 16,
    xxl: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: 110
    }
  }, /*#__PURE__*/_react.default.createElement("h4", null, "\u0928\u0940\u091A\u0947 \u0926\u093F\u090F \u0917\u090F 6 \u092A\u0948\u0930\u0947\u0902\u091F \u092E\u0947\u0902 \u0938\u0947 \u0915\u093F\u0938\u0940 2 \u092A\u0948\u0930\u0947\u0902\u091F \u0915\u093E \u0911\u0921\u093F\u091F \u092D\u0930\u0947 \u0964"))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 4,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: 110
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Progress, {
    status: filledData < 2 ? "exception" : "success",
    percent: filledData / 2 * 100,
    format: function format(percent) {
      return "".concat(percent, "% Audit");
    },
    type: "circle",
    width: 80
  }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 4,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_DataDisplayWidget.default, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserSwitchOutlined, null),
    value: newFourParent.length,
    title: "Total Student",
    color: "cyan",
    size: 5,
    vertical: true,
    avatarSize: 20,
    style: {
      height: 110
    }
  }))))), /*#__PURE__*/_react.default.createElement(_antd.Card, null, /*#__PURE__*/_react.default.createElement(_antd.Form, {
    form: form,
    name: "basic",
    initialValues: {
      remember: true
    },
    onFinish: "onFinish"
  }, /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
    onChange: panelChange,
    accordion: true
  }, fourParent ? fourParent.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(Panel, {
      header: "".concat(item.Student_name, " - ").concat(item.Token_no),
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 24]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      style: {
        'backgroundColor': 'lavender',
        'textAlign': 'center'
      }
    }, "Student Info"), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [24, 24]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 14,
      style: {
        'textAlign': 'right'
      }
    }, /*#__PURE__*/_react.default.createElement("b", null, "Token Number:")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, item.Token_no)), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [24, 24]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 14,
      style: {
        'textAlign': 'right'
      }
    }, /*#__PURE__*/_react.default.createElement("b", null, "Student Name:")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, item.Student_name)), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [24, 24]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 14,
      style: {
        'textAlign': 'right'
      }
    }, /*#__PURE__*/_react.default.createElement("b", null, "Mother Name:")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, item.Mother_name)), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [24, 24]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 14,
      style: {
        'textAlign': 'right'
      }
    }, /*#__PURE__*/_react.default.createElement("b", null, "Phone Number:")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, item.Calling_no))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      style: {
        'backgroundColor': 'lavender',
        'textAlign': 'center'
      }
    }, "Audit Parent"), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      value: "RM_send_morning_messages",
      onChange: selectOption
    }, "\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0930\u094B\u091C \u0938\u0941\u092C\u0939 \u0906\u0930\u090F\u092E \u092E\u0947\u0938\u0947\u091C \u092D\u0947\u091C\u0924\u0940 \u0939\u0948?")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      value: "Does_RM_follow_up",
      onChange: selectOption
    }, "\u0905\u0917\u0930 \u0915\u092D\u0940 \u0906\u092A \u0930\u093F\u092A\u094D\u0932\u093E\u0908 \u0928\u0939\u0940 \u0915\u0930 \u092A\u093E\u0924\u0947 \u0906\u0930\u090F\u092E \u092B\u0949\u0932\u094B \u0905\u092A \u0932\u0947\u0924\u0940 \u0939\u0948?")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      value: "Does_RM_tell_marks_daily",
      onChange: selectOption
    }, "\u0906\u0930\u090F\u092E \u0906\u092A\u0915\u094B \u0906\u092A\u0915\u0947 \u092C\u091A\u094D\u091A\u0947 \u0915\u0947 \u092E\u093E\u0930\u094D\u0915\u094D\u0938 \u0930\u094B\u091C\u093C \u092C\u0924\u093E\u0924\u0940 \u0939\u0948?")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 24
    }, /*#__PURE__*/_react.default.createElement("label", null, "\u0906\u092A \u0939\u092B\u094D\u0924\u0947 \u092E\u0947\u0902 \u0915\u093F\u0924\u0928\u0947 \u0926\u093F\u0928 \u0915\u093E\u092E \u0915\u0930\u0924\u0947 \u0939\u094B?"), /*#__PURE__*/_react.default.createElement(_antd.Radio.Group, {
      onChange: onChange
    }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
      direction: "vertical"
    }, /*#__PURE__*/_react.default.createElement(_antd.Radio, {
      value: "0"
    }, "1 \u0938\u0947 2 \u0926\u093F\u0928"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
      value: "1"
    }, "3 \u0938\u0947 4 \u0926\u093F\u0928"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
      value: "2"
    }, "5 \u0938\u0947 6 \u0926\u093F\u0928"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
      value: "3"
    }, "0 \u0926\u093F\u0928 \u0915\u093E\u092E \u0915\u0930\u0924\u0947 \u0939\u094B")))))));
  }) : null), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 18,
    xl: 20,
    xxl: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    onClick: back,
    type: "link",
    className: "m-2"
  }, "Go Back")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 6,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    className: "m-2",
    type: "primary",
    onClick: submit
  }, "Submit"))))), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "Warning!!!",
    visible: warningBack,
    okText: "No",
    cancelText: "Yes",
    onOk: back,
    onCancel: cancel
  }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement(_icons.ExclamationCircleOutlined, {
    style: {
      color: "orange"
    }
  }), " \u0915\u094D\u092F\u093E \u0906\u092A \u0935\u093E\u092A\u0938 \u091C\u093E\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u094B ? "), /*#__PURE__*/_react.default.createElement("p", null, "\u0905\u0917\u0930 \u0906\u092A \u0935\u093E\u092A\u0938 \u0917\u090F \u0924\u094B \u0906\u092A\u0915\u093E \u092D\u0930\u093E \u0939\u0941\u0906 \u0921\u093E\u091F\u093E \u0939\u091F \u091C\u093E\u090F\u0917\u093E \u0964")));
};

var _default = ParentAudit;
exports.default = _default;